// extracted by css-extract-rspack-plugin
export default {"modal":"modal-Qh0sI3"};